import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { TManagerReviewFile } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/types.ts';

type TManagerFormValues = {
  documents: {
    comment: string;
  }[];
};

type TUseManagerApplicationDocumentsTableFormParams = {
  reviewFiles: TManagerReviewFile[];
  comments: Record<string, string>;
};

const buildDefaultValues = (
  reviewFiles: TManagerReviewFile[],
  comments: Record<string, string>
): TManagerFormValues => ({
  documents: reviewFiles.map((document) => ({
    comment: comments[document.id] ?? document.comment ?? '',
  })),
});

export const useManagerApplicationDocumentsTableForm = ({
  reviewFiles,
  comments,
}: TUseManagerApplicationDocumentsTableFormParams) => {
  const formMethods = useForm<TManagerFormValues>({
    defaultValues: buildDefaultValues(reviewFiles, comments),
  });

  useEffect(() => {
    formMethods.reset(buildDefaultValues(reviewFiles, comments));
  }, [comments, reviewFiles, formMethods]);

  return formMethods;
};

export default useManagerApplicationDocumentsTableForm;
